import i18n from '@/i18n'
import { mcToast } from '@/plugins/McToastAlertPlugin'
import store from '@/state/store'

export const state = {
  type: null,
  message: null,
  licenseNew: false,
  config: {
    time: {
      key: 10,
      label: '10 Detik',
    },
    alertCodes: [],
    alertSounds: [],
  },
  status: '',
  detailNotification: null,
  listNotificationMedia: null,
  statusTextVehicleActive: null,
  deviceTypeActive: null,
  uploadVideoProcessing: false,
  popupState: {
    alertCenterPopup: false,
    popupPosition: { x: 100, y: 100 },
  },
  activePopups: [],
  alertList: [],
  newAlertRules: false,
}

export const mutations = {
  SET_STATUS(state, payload) {
    state.status = payload
  },
  success(state, message) {
    state.type = 'alert-success'
    state.message = message
  },
  error(state, message) {
    state.type = 'alert-danger'
    state.message = message
  },
  clear(state) {
    state.type = null
    state.message = null
  },
  configPopUp(state, payload) {
    state.config = payload
  },
  setDetailNotification(state, payload) {
    state.detailNotification = payload
  },
  setListNotificationMedia(state, payload) {
    state.listNotificationMedia = payload
  },
  setStatusTextVehicleActive(state, payload) {
    state.statusTextVehicleActive = payload
  },
  setDeviceTypeActive(state, payload) {
    state.deviceTypeActive = payload
  },
  setUploadVideoProcessing(state, payload) {
    state.uploadVideoProcessing = payload
  },
  setPopupState(state, newState) {
    state.popupState = { ...state.popupState, ...newState }
  },
  ADD_POPUP(state, popup) {
    state.activePopups.push(popup)
    localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
  },
  REMOVE_POPUP(state, alertId) {
    const index = state.activePopups.findIndex((popup) => popup.alert.id === alertId)
    if (index !== -1) {
      state.activePopups.splice(index, 1)
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
  },
  UPDATE_POPUP_POSITION(state, { id, x, y }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.x = x
      popup.y = y
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
  },
  UPDATE_POPUP_MEDIA(state, { id, pollingStatus, canCheck, canRequest, retryCount, videoData }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.alert.pollingStatus = pollingStatus
      popup.alert.videoData = videoData
      popup.alert.canCheck = canCheck
      popup.alert.canRequest = canRequest
      popup.alert.retryCount = retryCount
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
  },
  LOAD_POPUPS(state, popups) {
    state.activePopups = popups
  },
  OPEN_POPUP_FORM(state, { id, formOpen }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.formOpen = formOpen
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
  },
  UPDATE_POPUP_FORM(state, { id, formData }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.form = formData
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
  },
  UPDATE_POPUP_FALSE_ALERT(state, { id, lastUserFeedback, isFalseAlert }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.alert.lastUserFeedback = lastUserFeedback
      popup.alert.isFalseAlert = isFalseAlert
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
    const alert = state.alertList.find((alert) => alert.id === id)
    if (alert) {
      alert.lastUserFeedback = lastUserFeedback
      alert.isFalseAlert = isFalseAlert
    }
  },
  UPDATE_POPUP_NOTE(state, { id, note }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.note = note
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
  },
  EDIT_NOTE(state, { id, disabledNote }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.disabledNote = disabledNote
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
  },
  SET_ALERT_LIST(state, alerts) {
    state.alertList = alerts
  },
  UPDATE_NOTE_ONLY(state, { id, note, disabledNote }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.note = note
      popup.disabledNote = disabledNote
    }
  },
  UPDATE_FALSE_ALERT(state, { id, lastUserFeedback, isFalseAlert }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.alert.lastUserFeedback = lastUserFeedback
      popup.alert.isFalseAlert = isFalseAlert
    }
  },
  RESET_NOTE_STATE(state, { id }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.note = ''
      popup.disabledNote = false

      if (popup.alert.lastUserFeedback) {
        popup.alert.lastUserFeedback = ''
      }
    }
    const alert = state.alertList.find((alert) => alert.id === id)
    if (alert) {
      alert.lastUserFeedback = ''
    }
  },
  UPDATE_FALSE_ALERT_ONLY(state, { id, lastUserFeedback }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      // Update status false alert tapi pertahankan note dan form
      popup.alert.lastUserFeedback = lastUserFeedback
    }
  },
  UPDATE_POPUP_RESOLVED(state, { id, isResolved }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.alert.isResolved = isResolved

      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
    const alert = state.alertList.find((alert) => alert.id === id)
    if (alert) {
      alert.isResolved = isResolved
    }
  },
  SET_NEW_ALERT_RULES(state, value) {
    state.newAlertRules = value
  },
}

export const actions = {
  success({ commit }, message) {
    commit('success', message)
  },
  error({ commit }, message) {
    commit('error', message)
  },
  clear({ commit }) {
    commit('clear')
  },
  addPopup({ commit, state }, { alert, form, formOpen }) {
    const isExists = state.activePopups.some((popup) => popup.alert.id === alert.id)
    if (isExists) return
    if (
      !store.getters['identity/hasAccess'](['e4f-auto-popup-urgent-alert:read']) &&
      state.activePopups.length >= 9
    ) {
      mcToast.warning(i18n.t('notification.text.limitNotification'))
      return
    }

    const newPopup = {
      id: alert.id,
      alert,
      form,
      formOpen,
      note: alert.lastUserFeedback ? alert.lastUserFeedback?.feedback : '',
      disabledNote: alert.lastUserFeedback ? true : false,
      x: Math.floor(Math.random() * 300),
      y: Math.floor(Math.random() * 300),
    }
    commit('ADD_POPUP', newPopup)
  },
  closePopup({ commit }, alertId) {
    commit('REMOVE_POPUP', alertId)
  },
  updatePosition({ commit }, { id, x, y }) {
    commit('UPDATE_POPUP_POSITION', { id, x, y })
  },
  updateMedia({ commit }, { id, pollingStatus, canCheck, canRequest, retryCount, videoData }) {
    commit('UPDATE_POPUP_MEDIA', {
      id,
      pollingStatus,
      canCheck,
      canRequest,
      retryCount,
      videoData,
    })
  },
  openPopupForm({ commit }, { id, formOpen }) {
    commit('OPEN_POPUP_FORM', { id, formOpen })
  },
  updatePopupForm({ commit }, { id, formData }) {
    commit('UPDATE_POPUP_FORM', { id, formData })
  },
  updatePopupFalseAlert({ commit }, { id, lastUserFeedback, isFalseAlert }) {
    commit('UPDATE_POPUP_FALSE_ALERT', { id, lastUserFeedback, isFalseAlert })
  },
  updatePopupNote({ commit }, { id, note }) {
    commit('UPDATE_POPUP_NOTE', { id, note })
  },
  editNote({ commit }, { id, disabledNote }) {
    commit('EDIT_NOTE', { id, disabledNote })
  },

  updateNoteOnly({ commit }, payload) {
    commit('UPDATE_NOTE_ONLY', payload)
  },

  updateFalseAlert({ commit }, payload) {
    commit('UPDATE_FALSE_ALERT', payload)
  },

  resetNoteState({ commit }, payload) {
    commit('RESET_NOTE_STATE', payload)
  },

  updatePopupResolved({ commit }, { id, isResolved }) {
    commit('UPDATE_POPUP_RESOLVED', { id, isResolved })
  },

  showNewAlertRulesToast({ commit }) {
    commit('SET_NEW_ALERT_RULES', true)
  },

  clearNewAlertRulesToast({ commit }) {
    commit('SET_NEW_ALERT_RULES', false)
  },
}
